var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Stack, TextField, Typography } from '@mui/material';
import { useAuth } from '@react-components/auth';
import { brand } from './brand';
import { AuthScaffold, BackLink, PrimaryButton, ScreenHeading } from './AuthScaffold';
var CODE_LENGTH = 6;
var fieldSx = {
    '& .MuiOutlinedInput-root': {
        bgcolor: brand.field,
        borderRadius: '10px',
        color: brand.textPrimary,
        '& fieldset': { borderColor: brand.fieldBorder },
        '&:hover fieldset': { borderColor: brand.fieldBorderHover },
        '&.Mui-focused fieldset': { borderColor: brand.primary }
    },
    '& input::placeholder': { color: brand.textMuted, opacity: 1 }
};
var errorSx = { color: 'error.light', fontSize: '0.85rem' };
/**
 * Six single-character boxes with auto-advance, backspace and paste support.
 * @param root0
 * @param root0.value
 * @param root0.onChange
 * @param root0.onComplete
 */
function CodeInput(_a) {
    var value = _a.value, onChange = _a.onChange, onComplete = _a.onComplete;
    var refs = useRef([]);
    var chars = value.padEnd(CODE_LENGTH).split('').slice(0, CODE_LENGTH);
    var setChar = function (index, char) {
        var _a;
        var next = value.padEnd(CODE_LENGTH).split('');
        next[index] = char;
        var joined = next.join('').replace(/\s+$/, '');
        onChange(joined);
        if (char && index < CODE_LENGTH - 1) {
            (_a = refs.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
        if (joined.length === CODE_LENGTH && !joined.includes(' ')) {
            onComplete === null || onComplete === void 0 ? void 0 : onComplete(joined);
        }
    };
    return (_jsx(Stack, { direction: "row", spacing: 1, justifyContent: "center", children: Array.from({ length: CODE_LENGTH }).map(function (_, i) { return (_jsx(TextField
        // eslint-disable-next-line react/no-array-index-key
        , { inputRef: function (el) {
                refs.current[i] = el;
            }, value: chars[i].trim(), onChange: function (e) {
                var char = e.target.value.replace(/[^a-zA-Z0-9]/g, '').slice(-1);
                setChar(i, char);
            }, onKeyDown: function (e) {
                var _a;
                if (e.key === 'Backspace' &&
                    !chars[i].trim() &&
                    i > 0) {
                    (_a = refs.current[i - 1]) === null || _a === void 0 ? void 0 : _a.focus();
                }
            }, onPaste: function (e) {
                var _a;
                var pasted = e.clipboardData
                    .getData('text')
                    .replace(/[^a-zA-Z0-9]/g, '')
                    .slice(0, CODE_LENGTH);
                if (pasted) {
                    e.preventDefault();
                    onChange(pasted);
                    if (pasted.length === CODE_LENGTH) {
                        onComplete === null || onComplete === void 0 ? void 0 : onComplete(pasted);
                    }
                    else {
                        (_a = refs.current[pasted.length]) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                }
            }, autoFocus: i === 0, inputProps: {
                inputMode: 'text',
                autoCapitalize: 'characters',
                maxLength: 1,
                'aria-label': "Character ".concat(i + 1),
                style: {
                    textAlign: 'center',
                    fontSize: '1.3rem',
                    fontFamily: brand.mono,
                    padding: '12px 0'
                }
            }, sx: __assign({ width: 46 }, fieldSx) }, i)); }) }));
}
/**
 * Phase 1 — collect the email address and request a code.
 * @param props - email value/handlers and send state.
 */
function EmailPhase(props) {
    var email = props.email, onEmailChange = props.onEmailChange, isValidEmail = props.isValidEmail, isSending = props.isSending, error = props.error, onSend = props.onSend;
    return (_jsxs(Stack, { spacing: 2.25, children: [_jsx(ScreenHeading, { title: "Sign in with a code", subtitle: "We'll email you a one-time code to sign in." }), _jsx(TextField, { type: "email", placeholder: "you@company.com", value: email, onChange: function (e) { return onEmailChange(e.target.value); }, onKeyDown: function (e) {
                    if (e.key === 'Enter' && isValidEmail && !isSending) {
                        onSend();
                    }
                }, autoFocus: true, fullWidth: true, error: !!email && !isValidEmail, sx: fieldSx }), error && _jsx(Typography, { sx: errorSx, children: error }), _jsx(PrimaryButton, { onClick: onSend, disabled: !isValidEmail || isSending, children: 'Send code' })] }));
}
/**
 * Phase 2 — enter the emailed 6-digit code (or resend it).
 * @param props - code value/handlers, send state and verify/resend callbacks.
 */
function CodePhase(props) {
    var email = props.email, code = props.code, onCodeChange = props.onCodeChange, isCodeComplete = props.isCodeComplete, isSending = props.isSending, error = props.error, onVerify = props.onVerify, onResend = props.onResend;
    return (_jsxs(Stack, { spacing: 2.25, children: [_jsx(ScreenHeading, { title: "Enter your code", subtitle: (_jsxs(_Fragment, { children: ['We sent a 6-digit code to', _jsx("br", {}), _jsx(Box, { component: "span", sx: { color: brand.textPrimary }, children: email })] })) }), _jsx(CodeInput, { value: code, onChange: onCodeChange, onComplete: function (c) { return onVerify(c); } }), error && (_jsx(Typography, { sx: __assign(__assign({}, errorSx), { textAlign: 'center' }), children: error })), _jsx(PrimaryButton, { onClick: function () { return onVerify(); }, disabled: !isCodeComplete, children: 'Verify' }), _jsxs(Typography, { sx: {
                    textAlign: 'center',
                    fontSize: '0.85rem',
                    color: brand.textSecondary
                }, children: ['Didn\'t get it? ', _jsx(Box, { component: "span", onClick: onResend, sx: {
                            color: brand.primary,
                            cursor: isSending ? 'default' : 'pointer',
                            fontWeight: 600,
                            opacity: isSending ? 0.5 : 1,
                            '&:hover': {
                                textDecoration: isSending ? 'none' : 'underline'
                            }
                        }, children: isSending ? 'Sent!' : 'Resend code' })] })] }));
}
/**
 * OtpPage — two-phase email code sign-in.
 *   Phase 1: enter email → sendOtpEmail (emails a 6-digit code + magic link)
 *   Phase 2: enter the 6-digit code → verifyOtpCode
 * All behavior comes from useAuth(); this is the sso2 presentation.
 * @param root0
 * @param root0.basePath
 */
export function OtpPage(_a) {
    var _this = this;
    var _b = _a.basePath, basePath = _b === void 0 ? '' : _b;
    var _c = useParams().companyKey, companyKey = _c === void 0 ? '' : _c;
    var navigate = useNavigate();
    var auth = useAuth();
    var _d = useState(''), email = _d[0], setEmail = _d[1];
    var _e = useState(false), emailSent = _e[0], setEmailSent = _e[1];
    var _f = useState(''), code = _f[0], setCode = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var _h = useState(false), isSending = _h[0], setIsSending = _h[1];
    var _j = useState(''), error = _j[0], setError = _j[1];
    useEffect(function () {
        if (companyKey) {
            auth.setCompanyKey(companyKey);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyKey]);
    var isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    var isCodeComplete = code.replace(/\s/g, '').length === CODE_LENGTH;
    var handleSend = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsSending(true);
                    setLoading(true);
                    setError('');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, auth.sendOtpEmail(email)];
                case 2:
                    _b.sent();
                    setEmailSent(true);
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    setError('Failed to send the code. Please try again.');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    // Keep resend disabled briefly to prevent double-sends
                    setTimeout(function () { return setIsSending(false); }, 3000);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleVerify = function (submitted) { return __awaiter(_this, void 0, void 0, function () {
        var finalCode, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    finalCode = (submitted !== null && submitted !== void 0 ? submitted : code).replace(/\s/g, '');
                    if (finalCode.length !== CODE_LENGTH) {
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    setError('');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, auth.verifyOtpCode(email, finalCode)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    setError('Invalid or expired code. Please try again.');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleResend = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSending) {
                        return [2 /*return*/];
                    }
                    setCode('');
                    setError('');
                    return [4 /*yield*/, handleSend()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBack = function () {
        if (emailSent) {
            setEmailSent(false);
            setCode('');
            setError('');
            return;
        }
        navigate("".concat(basePath ? "/".concat(basePath) : '', "/").concat(companyKey));
    };
    if (loading) {
        return (_jsx(AuthScaffold, { children: _jsxs(Stack, { spacing: 1.5, alignItems: "center", sx: { py: 2 }, children: [_jsx(CircularProgress, { sx: { color: brand.primary } }), _jsx(Typography, { sx: { color: brand.textSecondary }, children: emailSent ? 'Verifying…' : 'Sending your code…' })] }) }));
    }
    return (_jsxs(AuthScaffold, { children: [_jsx(BackLink, { onClick: handleBack }), emailSent ? (_jsx(CodePhase, { email: email, code: code, onCodeChange: setCode, isCodeComplete: isCodeComplete, isSending: isSending, error: error, onVerify: handleVerify, onResend: handleResend })) : (_jsx(EmailPhase, { email: email, onEmailChange: setEmail, isValidEmail: isValidEmail, isSending: isSending, error: error, onSend: handleSend }))] }));
}
export default OtpPage;
